/**
 * Tipos de aviso que la psicóloga podrá prender o apagar de a uno en la pestaña Notificaciones.
 *
 * HOY ESTÁ VACÍO: por ahora solo existe el interruptor general de las push del dispositivo. La pantalla
 * (`PwaNotificaciones`) ya está armada para esto: en cuanto esta lista tenga entradas, aparece la sección
 * "Qué avisos querés recibir" con una fila por tipo.
 *
 * Para sumar un tipo: (1) agregarlo acá, (2) guardar la preferencia por psicóloga en psiplatform-be, (3) que el
 * backend la respete al mandar (`PushSenderService`), (4) conectar el interruptor de su fila.
 */
export interface NotificationType {
  /** Clave estable (se guarda en el backend): nunca cambiarla una vez publicada. */
  key: string;
  label: string;
  description: string;
}

export const NOTIFICATION_TYPES: readonly NotificationType[] = [];
